module.exports = __webpack_public_path__ + "img/attack.ea61118a.png";